// updateCart
// $(document).ready(function() {
//    $('body').on('keyup','.measurement-per-unit', function() {
//      var btn=$('.update_btn');
//      $(btn).prop('disabled', true);
//         if($(this).val != ''){
//            $(btn).prop('disabled', false);
//         }
//     });
// })
// $(document).ready(function() {
//    $('body').on('keyup','.measurement-quantity', function() {
//      var btn=$('.update_btn');
//      $(btn).prop('disabled', true);
//         if($(this).val != ''){
//            $(btn).prop('disabled', false);
//         }
//     });
// })
// $(document).ready(function() {
//    $('body').on('click','.plus', function() {
//      var btn=$('.update_btn');
//      $(btn).prop('disabled', true);
//         if($(this).val != ''){
//            $(btn).prop('disabled', false);
//         }
//     });
// })
// $('body').on('keyup', '.measurement-per-unit', function(e) {
//   e.preventDefault();
//   const input = $(this);
//   var key=$(input).attr('key');
//   const newQuantity = Number(input.val());
//   const areaPerBox = 1.44; 
//   const newMeasurement = newQuantity * areaPerBox;
//   var d=$('.measurement-quantity');
//    $(d).each(function(i,ele) {
//       var item = $(this);
//       var key2 = item.attr('key2');
//      if(key==key2){     
//     $(ele).val(newMeasurement.toFixed(2));
//      }
//     });  
// }) 

// $('body').on('keyup', '.measurement-quantity', function(e) {
//   e.preventDefault();
//   const input = $(this);
//   var key2=$(input).attr('key2');
//   const newQuantity = Number(input.val());
//   const areaPerBox = 1.44; 
//   const newMeasurement =parseInt(newQuantity / areaPerBox + 1);
//   var d=$('.measurement-per-unit');
//    $(d).each(function(i,ele) {
//       var item = $(this);
//       var key = item.attr('key');
//      if(key==key2){     
//     $(ele).val(newMeasurement);
//      }
//     });  
// })


// $('body').on('click', '.plus', function() {
//     var $input = $(this).parent().find('input');
//     $input.val(parseInt($input.val()) + 1).trigger('keyup');
//     return false;
// });
// $('body').on('click', '.minus', function() {
//     var $input = $(this).parent().find('input');
//     $input.val(parseInt($input.val()) - 1).trigger('keyup');
//     return false;
// });



// Click event for manual "Update Cart" button
// $('body').on('click', '.actions button', function(e) {
//     e.preventDefault();
//     updateCartFromForm();
// });





// $('body').on('click', '.actions button', function(e) {
//     e.preventDefault();
//     var form = $(this).closest('form');    
//     let updates = {};
//     $(form).find('.woocommerce-cart-form__cart-item').each(function() {
//         const item = $(this);
//         const key = item.attr("data-line-item-key");
//         const newQuantity = Number(item.find('.measurement-per-unit').val());
//         if (newQuantity !== '' && newQuantity >= 0) {
//             updates[key] = newQuantity;
//         }
//     });

//     if (Object.keys(updates).length > 0) {
//         updateCart(updates);
//     } else {
//         console.log("No valid updates");
//     }
// });
//  $(document).on("click", "#zip_search", function() {
//     console.log("111111111111111")
//    var postal_code =  $('#postal_code').val();
//     console.log("postal_code",postal_code);
//    // var input_postcode = $('#input_postcode').text(postal_code)
//   $('#input_postcode').val(postal_code);
//    $("#search_postcode").trigger("click");
//        // $(".error-cls #postal-code-error").hide();
//      setTimeout(function() {
//         if ($(".error-cls #postal-code-error").is(":visible")) {
//             // $('.search-content-wrap').remove();
//            $(".appended-shipping").remove();
//         } else {
//             $(".appended-shipping").remove();
//             var shippingElement = $("#shipping_rates").clone();
//             if (shippingElement.length > 0) {
//                 shippingElement.css("display", "block").addClass("appended-shipping");
//                 $(".input-content-block").after(shippingElement);
//             }
//         }
//     }, 1000);
   
// });

// if($('input#csDatepicker').val()== null || $('input#csDatepicker').val()== ''){
//   $(".appended-shipping").hide();
// }else{
//  $(".appended-shipping").show();
// }

// $(document).on("click", "#zip_search", function() {
//     var postal_code = $('#postal_code').val();

//     $('#input_postcode').val(postal_code);
//     $("#search_postcode").trigger("click");

//     setTimeout(function() {
//         $(".appended-shipping").remove();
//         $("#hidden-shipping-message").remove();
      
//         if ($("#cs_shipping_rate .form .ShippingEstimator__Error ").hasClass("activeMsg")) {
//             var errorMessage = $("#cs_shipping_rate .form").attr('data-ship_err');
//             if (errorMessage.length > 0) {
//                 $(".input-content-block").after('<div id="hidden-shipping-message" class="shipping-mass" style="display: block;color: red;"></div>');
//                 $("#hidden-shipping-message").append(errorMessage);
//             }
//         } else {
//             // Store success message but don't show it yet
//             var shippingElement = $("#shipping_rates").clone();   
          
//             if (shippingElement.length > 0) {
//                 shippingElement.css("display", "block").addClass("appended-shipping");
//                 $(".input-content-block").after('<div id="hidden-shipping-message" style="display: none;"></div>');
//                 $("#hidden-shipping-message").append(shippingElement);
//             }
//         }
//     }, 2000);
// });

// $(document).on("input blur", "#csDatepicker", function() {
//     var selectedDate = $(this).val();
//   console.log(54432354);
//     if (selectedDate.trim() !== "") {
//         $("#hidden-shipping-message").css("display", "block");
//     } 
// });
// function sbzDateUpdate(dateText) {
//   if (dateText && $('.cs-tab_last[rel="cs-tab2"]').hasClass('active')) {

var xq = 0;
var wcounter = 0;
function csOuterfunction() {
  if (csJq('.cs-tab_last[rel="cs-tab2"]').hasClass('active') == true) {
    csJq('#cs-tab1').hide()
    csJq('#cs-tab2').show()
    csJq('#postal_code').val('hg58ld');
    csJq('#zip_search').click();
    var new_action_url = csJq(csCartFormSelector).attr("action").replace('hg58ld', '').replace('hg5 8ld', '');
    csJq(csCartFormSelector).attr("action", new_action_url);
  }
  if (csJq('.cs-tab_last[rel="cs-tab3"]').hasClass('active') == true) {
    csJq('.cs-radio-card').click();
  }
  setTimeout(function () {

    $.getJSON('/cart.js', function (cart) {
      $('.ers').remove();

      // now have access to Shopify cart object
      var hasbaspoke = false, hasNull = false;
      $(cart.items).each(function (index, val) {
        if (val.product_type == null) {
          xq = 1;
        }
        console.log(val.product_type, 'www');
        if (val.product_type == 'Bespoke') {
          hasbaspoke = true;
          xq = 0;
        }
      });
      if (xq == 1) {
        wcounter = wcounter + 1;
        console.log(wcounter, 'wcounter');
        if (wcounter > 2) {
          location.reload();
        }
        $('.shipping-option').append('<div class="ers">Please wait...</div>');
        $('#postal_code').attr('disabled', 'disabled');

        setTimeout(function () {
          csOuterfunction();
        }, 2000);
        return false;
      }
      $('.ers').remove();
      $('#postal_code').removeAttr('disabled');

      if (hasbaspoke) {
        // window.setMaxDays = 21;
        //$('#csShippingAppCode .CS-custom-tab-section .cs-crawler-tabs li[rel="cs-tab3"]').hide();
      } else {
        if (cart.item_count > 0) {
          $('#csShippingAppCode .CS-custom-tab-section .cs-crawler-tabs li[rel="cs-tab3"]').show();
        } else {
          $('#csShippingAppCode .CS-custom-tab-section .cs-crawler-tabs li[rel="cs-tab3"],#csShippingAppCode').hide();
        }
      }
    });
  }, 2000);

  if (csJq('#postal_code').val().length != 0) {
    csJq('#address_zip').val(csJq('#postal_code').val());
    //       setTimeout(function(){
    //         csJq('.get-rates').trigger('click');
    //       },300)
  }


  csJq(document).on("keyup", "#postal_code", function (e) {
    var postal = csJq("#postal_code").val().replace(/\s+/g, '');
    var s = /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/;
    if (!s.test(postal.toUpperCase())) {
      return false;
    }
    csJq('#address_zip').val(postal);
    setTimeout(function () {
      if (csJq('#csDatepicker').val().length != 0) {
        csJq('#zip_search').trigger('click');
        //         csJq('.get-rates').trigger('click');
      }
    }, 300)

  });
  if ($('input#csDatepicker').val() == null || $('input#csDatepicker').val() == '') {
    $('[name="checkout"]').addClass('pointerNone');
  } else {
    $('[name="checkout"]').removeClass('pointerNone');
  }
}
function sbzDateUpdate(dateText) {
  if (dateText == '') {
    $('[name="checkout"]').addClass('pointerNone');
  } else {
    $('[name="checkout"]').removeClass('pointerNone');
  }
  if ($('input#csDatepicker').val() == null || $('input#csDatepicker').val() == '') {
    return false;
  }
  if (csJq('.cs-tab_last[rel="cs-tab2"]').hasClass('active')) {
    console.log(666666666);
    var new_action_url = csJq(csCartFormSelector).attr("action").replace('hg58ld', '').replace('hg5 8ld', '');
    csJq(csCartFormSelector).attr("action", new_action_url);
  }
}
function AfterUpdate(cart, csLineProp) {
  if (csJq('.cs-tab_last[rel="cs-tab2"]').hasClass('active')) {
    if (csJq("#postal_code").val() == '' || csJq("#postal_code").val() == null) {
      return false;
    }
  } else if (csJq('.cs-tab_last[rel="cs-tab3"]').hasClass('active')) {
    if (csJq("#csDatepicker1").val() == '' || csJq("#csDatepicker1").val() == null) {
      return false;
    }
  }

  var postal = csJq("#postal_code").val().replace(/\s+/g, '')
  csJq('#address_zip,#input_postcode').val(postal);
}

function sbzMethodChange(csTabVal) {
  $('[name="checkout"]').addClass('pointerNone');
  if (csTabVal == 'cs-tab3') {
    $('span#postal-code-error').text('Please choose a location and choose a date')
    csJq('.cs-radio-card').click();
  }
  if (csTabVal == 'cs-tab2') {
    $('span#postal-code-error').text('Please enter a postcode and choose a date')
    csJq('#postal_code').val('hg58ld');
    csJq('#zip_search').click();
    // var new_action_url = typeof action_url != 'undefined' ? action_url.replace('hg58ld', '').replace('hg5 8ld', '') : csJq(csCartFormSelector).attr("action").replace('hg58ld', '').replace('hg5 8ld', '');
    // csJq(csCartFormSelector).attr("action", new_action_url);
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const targetNode = document.getElementById('csShippingAppCode');
  if (!targetNode) return;

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const zip_search = document.getElementById('zip_search');
          if (zip_search) {
            zip_search.innerHTML = 'Submit';
          }

          const postal_code = document.getElementById('postal_code');
          if (postal_code) {
            postal_code.setAttribute(
              'placeholder',
              'Enter your postal code'
            );
          }

          if (node.id === 'zip_search') {
            node.innerHTML = 'Submit';
          }
        }
      });
    });
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
});


function refreshCart() {
  $.ajax({
    url: '/cart?t='+Math.random(),
    method: 'GET',
    dataType: 'html',
    success: function(data) {  
      var formContent=$(data).find('[clear]');
      $('[clear]').html(formContent.html());
      
    },
    error: function(error) {
      console.log("Refresh Cart Error:", error);
     
    }
  });
}
$('body').on('keyup', '.measurement-per-unit', function(e) {
  console.log("hii");
  // e.preventDefault();
  const input = $(this);
   measurementPerUnit(input);
  
});

function measurementPerUnit(input) {
  // const input = $(input);
  var key = $(input).attr('key');
  const newQuantity = Number(input.val());
  const areaPerBox = $(input).attr("data-m2"); 
  const newMeasurement = newQuantity * areaPerBox;
  $('.measurement-quantity').each(function() {
    var item = $(this);
    var key2 = item.attr('key2');
    if (key == key2) {     
      $(item).val(newMeasurement.toFixed(2));
    }
  });  
  $(input).parents(".woocommerce-cart-form__cart-item").addClass("loader_active");    
  updateCartFromForm();
}

$('body').on('keyup', '.measurement-quantity', function(e) {
  // e.preventDefault();
   const input = $(this);
  
 measurementQuantity(input);
      
});

function measurementQuantity(input) {
   // const input = $(input);
  var key2 = $(input).attr('key2');
  const newQuantity = Number(input.val());
  const areaPerBox = $(input).attr("data-m2"); 
  const newMeasurement = Math.ceil(newQuantity / areaPerBox); 
  
  $('.measurement-per-unit').each(function() {
    var item = $(this);
    var key = item.attr('key');
    if (key == key2) {         
      $(item).val(newMeasurement);
    }
  });  
  $(input).parents(".woocommerce-cart-form__cart-item").addClass("loader_active");  
   updateCartFromForm();
}

 $('body').on('click', '.plus, .minus', function() { 
    var $input = $(this).parent().find('.measurement-per-unit');
    var newValue = parseInt($input.val()) + ($(this).hasClass('plus') ? 1 : -1);
   $input.val(newValue)
     var input= $(this).parent().find('.measurement-per-unit');
     var input2= $(this).parent().find('.measurement-quantity');
   
     measurementPerUnit(input)
   measurementQuantity(input2)
    // if (newValue < 1){
    //    var $item = $(this).closest(".update-cart");
    //    var key = $item.attr("data-line-item-key");
    //    removeItem(key);
    // }
      // $input.val(newValue).trigger('keyup');
  
    // updateCartFromForm();
    // return false;
});

function updateCartFromForm() {
    let updates = {};
    $('.woocommerce-cart-form__cart-item').each(function() {
      // $(this).addClass("loader_active");
        const item = $(this);
        const key = item.attr("data-line-item-key");
        const newQuantity = Number(item.find('.measurement-per-unit').val());
        if (!isNaN(newQuantity) && newQuantity >= 0) {
            updates[key] = newQuantity;
        }
    });

    if (Object.keys(updates).length > 0) {
        updateCart(updates);
    } else {
        console.log("No valid updates");
    }
}


function updateCart(updates) {
   $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ updates: updates }),
      dataType: 'json',
      success: function(data) {  
        refreshCart();
        countCart();
      },
     complete: function() {
        $(".woocommerce-cart-form__cart-item").removeClass("loader_active");
      },
      error: function(response) {
        console.log("Update Cart Error:", response);    
      }
    });
}


// remove cart

$(document).off('click', '.product-remove .remove').on('click', '.product-remove .remove', function(e) {
  e.preventDefault();
  var $item = $(this).closest(".update-cart");
  var key = $item.attr("data-line-item-key");
  $(this).parents(".woocommerce-cart-form__cart-item").addClass("loader_active");
 removeItem(key);
});
function removeItem(key) {
  $.ajax({
    url: '/cart/update.js',
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ updates: { [key]: 0 } }),
    dataType: 'json',
    success: function(data) {
       $('.remove-cart').each(function() {
          var $item = $(this);
          var key = $item.attr('data-line-item-key');
          var exists = data.items.some(function(item) {
              return item.key === key;
          });
          if (!exists) {
            $item.remove();
          }
         countCart();
        refreshCart();
      });  
    },
    complete: function() {
        $(".woocommerce-cart-form__cart-item").removeClass("loader_active");
      },
    error: function(error) {
      console.log("Remove Cart Error:", error);
    }
  });

}